export const addDays = (days: number, baseDate: Date = new Date()) =>
  new Date(new Date(baseDate).setDate(baseDate.getDate() + days))
